module.exports = __webpack_public_path__ + "img/690703afacdea6a677c45987651b424e.png";